var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.list.editMode && _vm.computedCanCreate)?_c('v-btn',{staticClass:"mr-3",attrs:{"depressed":"","outlined":"","color":"primary"},on:{"click":function($event){return _vm.$emit('create')}}},[_c('v-icon',{attrs:{"left":""}},[_vm._v("mdi-plus")]),_c('span',[_vm._v(_vm._s(_vm.createButtonName))])],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }